import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import BasicLayout from '@/layout/BasicLayout'
import { message } from 'ant-design-vue'
import { refreshToken } from '@/plugins/service'

sessionStorage.removeItem('currentWT')
Vue.prototype.$message = message
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return originalPush.call(this, location).catch(err => err)
}

Vue.use(VueRouter)

const routes = [
  {
    path: '/equipment',
    component: BasicLayout,
    children: [
      {
        path: '/equipment/list',
        name: 'list',
        component: () => import('@/views/EquipmentManager/EquipmentList'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/equipment/list/submit/add',
        component: () => import('@/views/EquipmentManager/EquipmentList/submit/add')
      },
      {
        path: '/equipment/list/submit/edit',
        component: () => import('@/views/EquipmentManager/EquipmentList/submit/edit')
      },
      {
        path: '/equipment/protocol',
        component: () => import('@/views/EquipmentManager/EquipmentProtocol'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/equipment/comprass',
        component: () => import('@/views/EquipmentManager/EquipmentComprass'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/equipment/protocol/submit',
        component: () => import('@/views/EquipmentManager/EquipmentProtocol/submit')
      },
      {
        path: '/maintain/data',
        component: () => import('@/views/EquipmentManager/MaintainData')
      },
      {
        path: '/equipment/preview',
        component: () => import('@/views/EquipmentManager/EquipmentList/PreviewGroup'),
        redirect: '/equipment/preview/statistics',
        children: [
          {
            path: 'statistics',
            component: () => import('@/views/EquipmentManager/EquipmentList/Detail')
          },
          // {
          //   path: 'setWarning',
          //   component: () => import('@/views/EquipmentManager/EquipmentList/Warning')
          // },
          {
            path: 'setWarning',
            component: () => import('@/views/EquipmentManager/EquipmentList/Warning/index.vue')
          },
          {
            path: "dataReport",
            component: () => import("@/views/EquipmentManager/EquipmentList/View/dataReport.vue")
          },
          {
            path: "dataStatistics",
            component: () => import("@/views/EquipmentManager/EquipmentList/View/dataStatistics.vue")
          }
        ]
      },
      {
        path: '/equipment/group',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/EquipmentManager/EquipmentGroup')
      },
      {
        path: '/equipment/group/submit',
        component: () => import('@/views/EquipmentManager/EquipmentGroup/submit')
      },
      {
        path: '/equipment/view',
        component: () => import('@/views/EquipmentManager/EquipmentList/View'),
        redirect: '/equipment/view/monitor',
        children: [
          {
            path: 'monitor',
            component: () => import('@/views/EquipmentManager/EquipmentList/View/Monitor')
          },
          {
            path: 'statistics',
            component: () => import('@/views/EquipmentManager/EquipmentList/View/Statistics')
          },
          {
            path: 'warning',
            component: () => import('@/views/EquipmentManager/EquipmentList/View/Warning')
          }
        ]
      },
      {
        path: '/equipment/warn',
        component: () => import('@/views/EquipmentManager/EquipmentWarnList/')
      },
      {
        path: '/equipment/linkage',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/EquipmentManager/Linkage')
      },
      {
        path: '/equipment/linkage/submit',
        component: () => import('@/views/EquipmentManager/Linkage/submit.vue')
      }
      // {
      //   path: '/equipment/warnDetail',
      //   component: () => import('@/views/EquipmentManager/EquipmentWarnList/WarnDetail')
      // }
    ]
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      {
        path: '/overview',
        component: () => import('@/views/Overview'),
        // redirect: '/equipment/group',
        children: [
          {
            path: 'service',
            component: () => import('@/views/Overview/components/Service'),
            name: 'service',
          },
          {
            path: 'monitor',
            component: () => import('@/views/Overview/components/Charts'),
            name: 'monitor'
          },
          {
            path: 'list',
            component: () => import('@/views/Overview/components/List')
          },
          {
            path: "bigData",
            component: () => import("@/views/Overview/components/BigData.vue")
          }
        ]
      },
      {
        path: '/menu',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Menu')
      },
      {
        path: '/sim',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/SIM')
      },
      {
        path: '/client',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Client')
      },
      {
        path: '/bind',
        component: () => import('@/views/Bind')
      },
      {
        path: '/order',
        component: () => import('@/views/Orders'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/service',
        component: () => import('@/views/Service'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/order/detail',
        component: () => import('@/views/Orders/details')
      },
      {
        path: '/order/operator',
        component: () => import('@/views/Orders/operators'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/organization',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Organization')
      },
      {
        path: '/user',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/User')
      },
      {
        path: '/analysis',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/User/components/AnalysisPage.vue')
      },
      {
        path: '/region',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Region')
      },
      {
        path: '/role',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Role')
      },
      {
        path: '/dict',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/DictView')
      },
      {
        path: '/list',
        meta: { exportType: 'compressorList', keepAlive: true },
        component: () => import('@/views/List')
      },
      {
        path: '/device/stats',
        component: () => import('@/views/stats')
      },
      {
        path: '/maintain',
        meta: { exportType: 'compressorMaintain' },
        component: () => import('@/views/Maintain')
      },
      {
        path: '/history',
        name: 'history',
        component: () => import('@/views/History')
      },
      {
        path: '/crmreport',
        meta: { exportType: 'reportColumns' },
        component: () => import('@/views/crmreport')
      },
      {
        path: '/parameter',
        component: () => import('@/views/parameter')
      },
      {
        path: '/customer',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/Customer')
        // component: () => import('@/views/Customer/details.vue')
      },
      {
        path: '/customer/detail',
        component: () => import('@/views/Customer/details.vue')
      },
      {
        path: '/customer/submit',
        component: () => import('@/views/Customer/submit.vue')
      },
      {
        path: '/customerMaintain',
        name: 'customerMaintain',
        component: () => import('@/views/crmreport/customerMaintain'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/renzhen',
        name: 'renzhen',
        component: () => import('@/views/crmreport/renzhen'),
      },
      {
        path: '/YSBStaff',
        name: 'YSBStaff',
        component: () => import('@/views/YSBStaff'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/visitRecords',
        name: 'visitRecords',
        component: () => import('@/views/crmreport/visitRecords'),
      },
      {
        path: '/46report',
        name: '46report',
        component: () => import('@/views/crmreport/46report'),
      },
      {
        path: '/RecordsPic',
        name: 'RecordsPic',
        component: () => import('@/views/crmreport/RecordsPic'),
      },
      {
        path: '/recordsList',
        name: 'recordsList',
        component: () => import('@/views/crm/recordsList'),
      },
      {
        path: '/calcCDL',
        name: 'calcCDL',
        component: () => import('@/views/crm/calcCDL'),
      },
      {
        path: '/funnelList',
        name: 'funnelList',
        component: () => import('@/views/crm/funnelList'),
      },
      {
        path: '/recordsListDetail',
        name: 'recordsListDetail',
        component: () => import('@/views/crm/recordsList/detail'),
      },
      {
        path: '/warning',
        component: () => import('@/views/Warning'),
        meta: {
          keepAlive: true
        }
      },
      {
        path: '/warning/air',
        meta: { warning: { key: 'AIR_INSUFFICIENCY', value: '气量不足预警' }, exportType: 'airWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/heat',
        meta: { warning: { key: 'HIGH_TEMPERATURE', value: '高温预警' }, exportType: 'heatWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/overflowing',
        meta: { warning: { key: 'OVER_CURRENT', value: '过流预警' }, exportType: 'overflowingWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/low',
        meta: { warning: { key: 'LOW_FREQUENCY', value: '低温预警' }, exportType: 'lowWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/inverter',
        meta: { warning: { key: 'INVERTER_HIGH_TEMPERATURE', value: '变频器高温' }, exportType: 'inverterWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/blocking',
        meta: { warning: { key: 'AIR_FILTER_BLOCKED', value: '空滤堵塞' }, exportType: 'blockingWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/overload',
        meta: { warning: { key: 'OVERLOAD', value: '空压机过载' }, exportType: 'overloadWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/oneyearout',
        meta: { warning: { key: 'MAINTAIN', value: '维保预警' }, exportType: 'oneyearoutWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/inspection',
        meta: { warning: { key: 'INSPECTION', value: '巡检预警' }, exportType: 'inspectionWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/error',
        meta: { warning: { key: 'ERROR', value: '故障预警' }, exportType: 'errorWarning', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/LOW_APPLY_PRESSURE',
        meta: { warning: { key: 'LOW_APPLY_PRESSURE', value: '应用压力低' }, exportType: 'LOW_APPLY_PRESSURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_AIR_FILTER_BLOCKED',
        meta: { warning: { key: 'EST_AIR_FILTER_BLOCKED', value: '空滤堵塞' }, exportType: 'EST_AIR_FILTER_BLOCKED', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_OIL_SEPARATOR_BLOCKED',
        meta: { warning: { key: 'EST_OIL_SEPARATOR_BLOCKED', value: '油分堵塞' }, exportType: 'EST_OIL_SEPARATOR_BLOCKED', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_HIGH_TEMPERATURE',
        meta: { warning: { key: 'EST_HIGH_TEMPERATURE', value: '高温预警' }, exportType: 'EST_HIGH_TEMPERATURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_AIR_INLET_TEMPERATURE',
        meta: { warning: { key: 'EST_AIR_INLET_TEMPERATURE', value: '进气高温' }, exportType: 'EST_AIR_INLET_TEMPERATURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_INVERTER_HIGH_TEMPERATURE',
        meta: { warning: { key: 'EST_INVERTER_HIGH_TEMPERATURE', value: '变频高温' }, exportType: 'EST_INVERTER_HIGH_TEMPERATURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_FAN_BOX_OVERLOAD',
        meta: { warning: { key: 'EST_FAN_BOX_OVERLOAD', value: '箱体风机过载' }, exportType: 'EST_FAN_BOX_OVERLOAD', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_ELECTRONIC_FAN_OVERLOAD',
        meta: { warning: { key: 'EST_ELECTRONIC_FAN_OVERLOAD', value: '电控风机过载' }, exportType: 'EST_ELECTRONIC_FAN_OVERLOAD', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_MOTOR_BEARING_HIGH_TEMPERATURE',
        meta: { warning: { key: 'EST_MOTOR_BEARING_HIGH_TEMPERATURE', value: '电机轴承高温' }, exportType: 'EST_MOTOR_BEARING_HIGH_TEMPERATURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_MOTOR_WINDING_HIGH_TEMPERATURE',
        meta: { warning: { key: 'EST_MOTOR_WINDING_HIGH_TEMPERATURE', value: '电机绕组高温' }, exportType: 'EST_MOTOR_WINDING_HIGH_TEMPERATURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_COOLING_WATER_BREAK',
        meta: { warning: { key: 'EST_COOLING_WATER_BREAK', value: '冷却水断开' }, exportType: 'EST_COOLING_WATER_BREAK', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/EST_LOW_OIL_INLET_PRESSURE',
        meta: { warning: { key: 'EST_LOW_OIL_INLET_PRESSURE', value: '进油压力低' }, exportType: 'EST_LOW_OIL_INLET_PRESSURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/ONE_YEAR_WITHOUT_MAINTAIN',
        meta: { warning: { key: 'ONE_YEAR_WITHOUT_MAINTAIN', value: '一年未保养' }, exportType: 'ONE_YEAR_WITHOUT_MAINTAIN', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/offline',
        meta: { warning: { key: 'OFFLINE', value: '离线预警' }, exportType: 'OFFLINE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/dryerForewarn',
        meta: { warning: { key: 'DRYER_FOREWARN', value: '冷干机预警' }, exportType: 'DRYER_FOREWARN', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/startFrequently',
        meta: { warning: { key: 'START_FREQUENTLY', value: '频繁启停' }, exportType: 'START_FREQUENTLY', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/loadFrequently',
        meta: { warning: { key: 'LOAD_FREQUENTLY', value: '频繁加卸载' }, exportType: 'LOAD_FREQUENTLY', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/overPressure',
        meta: { warning: { key: 'OVER_PRESSURE', value: '超压运行' }, exportType: 'OVER_PRESSURE', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/motorht',
        meta: { warning: { key: 'MOTOR_HT', value: '电机温升高' }, exportType: 'MOTOR_HT', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: '/warning/outElectricTrend',
        meta: { warning: { key: 'OUT_ELECTRIC_TREND', value: '电流趋势预警' }, exportType: 'OUT_ELECTRIC_TREND', keepAlive: true },
        component: () => import('@/views/Warning')
      },
      {
        path: "/warning/emv",
        meta: {
          warning: {
            key: "EST_MACHINE_VIBRATION",
            value: "主机振动"
          },
          exportType: "EST_MACHINE_VIBRATION",
          keepAlive: true
        },
        component: () => import("@/views/Warning")
      },
      {
        path: "/warning/oilError",
        meta: {
          warning: {
            key: "EST_OIL_SEPARATOR_RETURN_ERROR",
            value: "油分回油异常"
          },
          exportType: "EST_OIL_SEPARATOR_RETURN_ERROR",
          keepAlive: true
        },
        component: () => import("@/views/Warning")
      },
      {
        path: "/warning/order",
        meta: {
          keepAlive: true
        },
        component: () => import("@/views/Warning/Order")
      },
      {
        path: '/system/log/device',
        meta: {
          keepAlive: true
        },
        component: () => import('@/views/System/Device')
      },
      {
        path: '/system/user',
        component: () => import('@/views/System/User')
      },
      {
        path: '/system/user_group',
        component: () => import('@/views/System/UserGroup')
      },
      {
        path: '/system/permission',
        component: () => import('@/views/System/Permission')
      },
      {
        path: '/system/equipment/resource',
        component: () => import('@/views/System/EquipmentResource')
      },
      {
        path: '/preview',
        // redirect: '/preview/detail',
        component: () => import('@/views/EquipmentManager/EquipmentGroupPreview'),
        children: [
          {
            path: '/preview/detail',
            component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/PreviewGroup')
          },
          {
            path: '/preview/statistics',
            component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/StatisticsGroup')
          },
          {
            path: '/preview/dataStatistics',
            component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/dataStatistics')
          },
          {
            path: '/preview/dataReport',
            component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/dataReport')
          },
          {
            path: '/preview/setWarning',
            component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/SetWarning')
          }
        ]
      },
      {
        path: '/system/driver/management',
        component: () => import('@/views/System/DriverManagement')
      },
      {
        path: '/customeService',
        component: () => import('@/views/crmreport/customeService')
      },
      {
        path: '/factory',
        component: () => import('@/views/Blank')
      },
      {
        path: '/factory/exhibit',
        component: () => import('@/views/Factory/Exhibit')
      },
      {
        path: '/module',
        component: () => import('@/views/EquipmentManager/Module')
      }
    ]
  },
  {
    path: '/46reportDetail',
    name: '46reportDetail',
    component: () => import('@/views/crmreport/46reportDetail'),
  },
  {
    path: '/fullscreen/preview1',
    component: () => import('@/views/EquipmentManager/EquipmentGroupPreview/components/fullscreenPreview1.vue')
  },
  {
    path: '/fullscreen/service',
    component: () => import('@/views/Overview/components/Service'),
    name: 'fullscreenservice'
  },
  {
    path: '/fullscreen/monitor',
    component: () => import('@/views/Overview/components/Charts'),
    name: 'fullscreenmonitor'
  },
  {
    path: '/fullscreen/list',
    component: () => import('@/views/Overview/components/List'),
    name: 'fullscreenlist'
  },
  {
    path: '/fullscreen/BigData',
    component: () => import('@/views/Overview/components/BigData.vue'),
    name: 'fullscreenBigData'
  },
  {
    path: '/equipment/group/detail',
    component: () => import('@/views/EquipmentManager/EquipmentGroupDetail')
  },
  {
    path: '/factory/mes',
    component: () => import('@/views/Factory/Mes')
  },
  // {
  //   path: '/equipment',
  //   component: () => import('@/views/EquipmentManager'),
  //   children: [
  //     {
  //       path: '/equipment/group/detail',
  //       component: () => import('@/views/EquipmentManager/EquipmentGroupDetail')
  //     }
  //   ]
  // },
  // {
  //   path: '/equipment/group/detail',
  //   component: () => import('@/views/EquipmentManager/EquipmentGroupDetail')
  // },
  {
    path: '/login',
    component: () => import('@/views/Login')
  },
  {
    path: '/404',
    component: () => import('@/views/NotFound')
  },
  {
    path: '*',
    redirect: '/404'
  },
  {
    path: '/factory/exhibit/table',
    component: () => import('@/views/Factory/Table')
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.query.token) {
    localStorage.setItem('token', JSON.stringify(to.query.token))
  }
  if (to.query.rToken) {
    localStorage.setItem('rToken', JSON.stringify(to.query.rToken))
  }
  const token = JSON.parse(localStorage.getItem('token'))
  if (to.path === '/login') {
    if (token) {
      next('/')
    } else {
      next()
    }
  } else if (to.path.startsWith('/factory')) {
    next()
  } else {
    if (!sessionStorage.getItem('currentWT') || (sessionStorage.getItem('currentWT') && to.path !== sessionStorage.getItem('currentWT'))) {
      store.commit('setWarnDeviceFlag', true)
    } else {
      store.commit('setWarnDeviceFlag', false)
    }
    if (token) {
      next()
    } else {
      // Vue.prototype.$message.warning('请登录', 1)
      await refreshToken(to.path)
      // next('/login')
    }
  }
})

let count = 0
router.onError((error) => {
  const pattern = /Loading chunk chunk-(.*)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    if (count > 0) {
      count = 0
    } else {
      count++
      const hide = message.loading('系统已升级，本地将自动更新，请稍后', 0);
      setTimeout(hide, 800)
      setTimeout(() => {
        window.location.reload(true)
      }, 800)
    }
  }
})

export default router
